<template>
	<div class="window-collapse-toggle-button" @click="toggle">
		<AppNotification
			v-if="hasNotification && isSettlementWindowCollapsed"
			value="!"
			:type="StatusTypes.WARNING"
		/>
		<div
			class="toggle-arrow"
			:class="[
				isSettlementWindowCollapsed
					? 'toggle-arrow--up arrow--up-26'
					: 'toggle-arrow--down arrow--down-26',
			]"
		/>
	</div>
</template>

<script lang="ts" setup>
import AppNotification from "@/components/AppNotification.vue";
import useRuntimeStore from "@/store/useRuntimeStore";
import { StatusTypes } from "@/types/ui";
import { storeToRefs } from "pinia";

interface Props {
	hasNotification?: boolean;
}

const { hasNotification = false } = defineProps<Props>();

const runtimeStore = useRuntimeStore();
const { isSettlementWindowCollapsed } = storeToRefs(runtimeStore);

const toggle = (): void => {
	runtimeStore.setIsSettlementWindowCollapsed(
		!isSettlementWindowCollapsed.value,
	);
};
</script>

<style lang="scss" scoped>
.window-collapse-toggle-button {
	display: flex;
	position: relative;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	box-shadow: inset 0 0 0.5rem 0 rgba(0, 0, 0, 0.3);
	border-width: 0.075rem;
	border-style: solid;
	border-image-source: linear-gradient(to top, #bd9032, #f0d386);
	border-image-slice: 1;
	background-image: linear-gradient(to top, #181a1d, #303239);
	width: 2.5rem;
	height: 2.5rem;

	:deep(.notification.notification--warning) {
		position: absolute;
		top: -0.625rem;
		left: 50%;
		transform: translateX(-50%);
		z-index: 2;
	}
}
</style>
